module.exports = "/_next/static/images/favicon-16x16-f92b155098b2d2b7fe3f70af7fa7c032.png";